module.exports = __webpack_public_path__ + "img/kv.d0de6197.png";